import Link from 'next/link'

import BEMHelper from '@/helpers/bem'
import styles from './styles/Entry.module.scss'
const bem = BEMHelper(styles)

interface Props {
  title: string
  description: string
  slug: string
}

export default function Entry({ title, description, slug }: Props) {
  if (!slug || !title || !description) {
    return null
  }

  return (
    <Link {...bem('')} href={`/tema/${slug}/introduksjon`}>
      <div {...bem('content')}>
        <h1 {...bem('title')}>{title}</h1>
        <p {...bem('description')}>{description}</p>
      </div>

      <picture>
        <source srcSet="/icons/introduksjon.webp" type="image/webp" />
        <source srcSet="/icons/introduksjon.png" type="image/png" />
        <img src="/icons/introduksjon.png" alt={title} width="300" {...bem('illustration')} />
      </picture>
    </Link>
  )
}
